//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"DisplayIntersectionCurves",1,0],[1,"FrontBottomOffset",0,"Expression",0],[1,"FrontClearance",0,"Expression",0],[1,"FrontFacetHubcap",0,"SelectNXObjectList",0],[1,"FrontFacetObject",0,"SelectNXObjectList",0],[1,"FrontFrontAngle",0,"Expression",0],[1,"FrontFrontOffset",0,"Expression",0],[1,"FrontHeight",0,"Expression",0],[1,"FrontHubcapSelection",0,"ScCollector",0],[1,"FrontObjectSelection",0,"ScCollector",0],[1,"FrontRadius",0,"Expression",0],[1,"FrontRearAngle",0,"Expression",0],[1,"FrontRearOffset",0,"Expression",0],[0,"FrontSurfacePlane",1,0],[0,"FrontSurfaceSection",1,0],[0,"Loading",1,0],[0,"Position",1,0],[1,"RearBottomOffset",0,"Expression",0],[1,"RearClearance",0,"Expression",0],[1,"RearDisToWheelCenter",0,"Expression",0],[1,"RearFacetHubcap",0,"SelectNXObjectList",0],[1,"RearFacetObject",0,"SelectNXObjectList",0],[1,"RearFrontAngle",0,"Expression",0],[1,"RearFrontOffset",0,"Expression",0],[1,"RearHeight",0,"Expression",0],[1,"RearHubcapSelection",0,"ScCollector",0],[1,"RearObjectSelection",0,"ScCollector",0],[1,"RearRadius",0,"Expression",0],[1,"RearRearAngle",0,"Expression",0],[1,"RearRearOffset",0,"Expression",0],[0,"RearSurfacePlane",1,0],[0,"RearSurfaceSection",1,0],[0,"RequirementsControl",1,0],[0,"Standard",1,0]],[],[]];
SPLM.Features.VehicleDesign.WheelCoveringBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.WheelCoveringBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.WheelCoveringBuilder.RequirementsControlType = Object.freeze({
    "StandardDriven" : "StandardDriven", "UserDefined" : "UserDefined"});

SPLM.Features.VehicleDesign.WheelCoveringBuilder.PositionType = Object.freeze({
    "Front" : "Front", "Rear" : "Rear", "Both" : "Both"});

SPLM.Features.VehicleDesign.WheelCoveringBuilder.SurfacePlaneType = Object.freeze({
    "WheelPlane" : "WheelPlane", "PerpendiculartoLoading" : "PerpendiculartoLoading"});

SPLM.Features.VehicleDesign.WheelCoveringBuilder.SurfaceSectionType = Object.freeze({
    "CircleSection" : "CircleSection", "Adr42" : "Adr42", "ExtrudeSection" : "ExtrudeSection"});

export default SPLM;